import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import "./legacy/firstdesk.css";
import "./legacy/firstdesk-landing.css";
import "./legacy/firstdesk-app.css";
import "./styles.css";

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
